// initial state
const state = () => ({
  // presenter info
  $presenter: {},
  // presenter state
  $state: {},
  // presenter data
  $data: {},
  // controls data
  $controls: {},
  // template id
  snippetName: 'Content'
})

// functionName: (state, getters, rootState) => {}
const getters = {
  currentState: (state) => {
    return state.$state[state.snippetName]
  },
  currentPresenter: (state) => {
    return state.$presenter[state.snippetName]
  }
}

// functionName ({ commit, state, dispatch }, param, ...) {}
const actions = {
  // updates data in store
  updateData ({ commit }, data) {
    const snippetName = data.state && data.state.snippetName ? data.state.snippetName : 'Content'
    console.log('updateData', { snippetName, data })
    
    if (data.state) {
      commit('setState', { data, snippetName })
    }
    
    if ('$controls' in data) {
      commit('updateControls', { controls: data.$controls, snippetName })
    }

    if (data.$data) {
      commit('updateData', { data: data.$data, snippetName })
    }
  },

  // replace data when root element rerender
  replaceData ({ commit }, data) {
    const snippetName = data.state && data.state.snippetName ? data.state.snippetName : 'Content'
    console.log('replaceData', { snippetName, data })
    commit('setState', { data, snippetName })
    if ('$controls' in data) {
      commit('replaceControls', { controls: data.$controls, snippetName })
    }
    commit('replaceData', { data: data.$data, snippetName })
  },

  // update one control
  updateControl ({ commit }, { controlName, data, key }) {
    console.log('updateControl', { controlName, data, key })
    commit('updateControl', { controlName, data, key })
  },

  updateDataKey ({ commit, state }, { data, key }) {
    const updated = {}
    updated[key] = data
    console.log('updateDataKey', updated)
    commit('updateData', { data: updated, snippetName: state.snippetName })
  }
}

// functionName (state, { param, ... }) {
const mutations = {
  setState(state, { data, snippetName }) {
    if (!(snippetName in state.$data)) {
      state.$data[snippetName] = {}
    }

    state.snippetName = snippetName
    if (data.state) {
      state.$state[snippetName] = data.state
    }

    if (data.presenter) {
      state.$presenter[snippetName] = data.presenter
    }
  },

  updateData(state, { data, snippetName }) {
    state.$data[snippetName] = {
      ...(state.$data[snippetName] || {}),
      ...data
    }
  },

  replaceData (state, { data, snippetName }) {
    const newData = {}
    newData[snippetName] = { ...data }
    state.$data = newData
  },

  updateControls (state, { controls }) {
    for (const k in controls) {
      state.$controls[k] = { ...state.$controls[k], ...controls[k] }
    }
  },

  replaceControls (state, { controls }) {
    state.$controls = { ...controls }
  },

  updateControl (state, { controlName, data, key }) {
    if (typeof key !== 'undefined') {
      if (!(controlName in state.$controls)) {
        state.$controls[controlName] = {}
        console.warn('Control with name ' + controlName + ' not exist when update called')
      }
      state.$controls[controlName][key] = data
    } else {
      state.$controls[controlName] = { ...state.$controls[controlName], ...data }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
